/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [CouponReducer, CouponSaga] = await Promise.all([
    import(/* webpackChunkName: "coupon" */ './Coupon.reducer'),
    import(/* webpackChunkName: "coupon" */ './Coupon.saga'),
  ]);
  useInjectReducerAndSaga(
    { key: 'CouponsAndPromos', reducer: CouponReducer.default },
    { key: 'CouponSaga', saga: CouponSaga.default }
  );
  return null;
};
